import * as React from "react"
import { Box } from "@mui/material"
import { AmchartSeeker,ModalSeeker } from "@ui-seeker/core"
import { isEmpty } from "@ui-seeker/utils"

import { usePriceDiscountStockEvolutionChartData } from "./@hooks"
import PriceDiscountStockEvolutionChartToolbar from "./Toolbar"


export default function PriceDiscountStockEvolutionChart() {

    const { dataEvolution, dataEvolutionKeys, dataEvolutionColor, skuName, retailerName, isLoadingDataEvolution, dateRange, onChange, resetEvolutionData } = usePriceDiscountStockEvolutionChartData()

	if (isEmpty(dataEvolution) || isLoadingDataEvolution ) return <></>

    return <ModalSeeker 
        hideActions 
        isOpen={!isEmpty(dataEvolution)} 
        title={`Stock Evolution - ${skuName} - ${retailerName}`} 
        controller={() => resetEvolutionData()}
        containerProps={{
            maxWidth:"xl"
        }}
    >
        <AmchartSeeker
            data={dataEvolution}
            title={<Box></Box>}
            pdfProps={{
                titlePDF:`Stock Evolution - ${skuName} - ${retailerName}`
            }}
            series={dataEvolutionKeys.map(key => ({
                name: key, 
                yField: key,
                xField: "date",
                connect: true,
                color: dataEvolutionColor[key],
                strokes: {
                    strokeDasharray: [0, 100000]
                },
                bullets: { 
                    hidden: false, 
                    radius: 20
                },
                tooltip: {
                    labelText: "[bold]{name}[/]"
                },
            }))}
            chartProps={{
                legend: { hidden: true },
                numberFormat: `#`,
                dateFormatReceived: 'yyyy-MM-dd',
                showBullets: true,
                xAxis: {
                    categoryField: 'date',
                    isDateAxis: true,
                    dateFormat: 'dd MMM yyyy',
                    hiddenGrid: true,
                    baseInterval: {
                        timeUnit: 'day',
                        count: 1
                    }
                },
                yAxis: {
                    hiddenLabels: true,
                    hiddenGrid: true
                }
            }}
            cardProps={{ actions: <PriceDiscountStockEvolutionChartToolbar dateRange={dateRange} onChange={onChange} /> }}
            sx={{ height: 300 }}
        />
    </ModalSeeker>
}